import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=2236af1e&scoped=true&lang=pug&"
import script from "./FAQs.vue?vue&type=script&lang=js&"
export * from "./FAQs.vue?vue&type=script&lang=js&"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=2236af1e&lang=scss&scoped=true&"
import style1 from "./FAQs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236af1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2236af1e')) {
      api.createRecord('2236af1e', component.options)
    } else {
      api.reload('2236af1e', component.options)
    }
    module.hot.accept("./FAQs.vue?vue&type=template&id=2236af1e&scoped=true&lang=pug&", function () {
      api.rerender('2236af1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/FAQs.vue"
export default component.exports